import { render, staticRenderFns } from "./PasswordSent.vue?vue&type=template&id=5b78666e&"
import script from "./PasswordSent.vue?vue&type=script&lang=js&"
export * from "./PasswordSent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports